import {getCookie} from "./getCookie";

export const getCookieByPrefix = (prefix) => {
  return document.cookie
    .split(";")
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith(prefix))
    ?.split("=")[0] || "";
};

export const getSessionData = (id) => {
  const regex = new RegExp(`${id}=GS\\d\\.\\d\\.(.+?)(?:;|$)`);
  const match = document.cookie.match(regex);
  const key = match ? match[1] : "";

  if (!key) return;
  
  if (key.startsWith("s")) return key.split("$")[0]

  return key.split(".")[0];
};

export const getG4Data = () => {
  const cookieKey = getCookieByPrefix("_ga_");
  const sessionId = getSessionData(cookieKey) || "";
  
  try {
    const gtagUAData = google_tag_data?.uach || {};
    const isUAVersionEnabled = Array.isArray(gtagUAData.fullVersionList)
    
    const userAgentVersionList = isUAVersionEnabled
      ? gtagUAData.fullVersionList.map(({ brand, version }) => `${brand};${version}`).join("| ")
      : "";
    
    return {
      cid: gaGlobal?.vid,
      session_id: sessionId,
      screen_resolution: `${screen.width}x${screen.height}`,
      uaa: gtagUAData.architecture,
      uab: parseInt(gtagUAData.bitness),
      uafvl: userAgentVersionList,
      uap: gtagUAData.platform,
      uapv: gtagUAData.platformVersion,
      page_location: document.location.href,
      page_referrer: document.referrer || "",
      page_title: document.title,
      affiliation: "Online Store",
      gclid: getCookie("gclid") || ""
    };
  } catch (e) {
    console.warn(e);
  }
};
